<template>
  <vx-card
    title="إعدادات أيام التوفر"
    class="mb-6"
    collapse-action
  >
    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <p
          class="mb-2"
          style="font-size: smaller"
        >
          إتاحة الخدمة للمتطوعين
        </p>
        <vs-switch
          v-model="config.isEnabled"
          icon-pack="feather"
          vs-icon="icon-check"
        />
        <p
          class="mt-2"
          style="font-size: smaller; color: rgb(184, 194, 204);"
        >
          عند الإيقاف تختفي صفحة "الأيام المتاحة" من تطبيق المتطوعين ولا يمكنهم إرسال أيام توفرهم.
        </p>
      </div>

      <div class="vx-col w-full mb-2">
        <p
          class="mb-2"
          style="font-size: smaller"
        >
          الأيام المتاحة للاختيار
        </p>
        <div
          class="flex flex-wrap"
          style="gap: 8px 24px;"
        >
          <vs-checkbox
            v-for="day in weekDays"
            :key="day.key"
            class="inline-flex"
            style="font-size: medium;"
            :vs-value="day.key"
            v-model="config.days"
          >
            {{ day.label }}
          </vs-checkbox>
        </div>
        <p
          v-if="config.isEnabled && !config.days.length"
          class="mt-3"
          style="font-size: smaller; color: rgb(var(--vs-warning));"
        >
          لم يتم تحديد أي يوم — لن يجد المتطوعون أي يوم لاختياره.
        </p>
      </div>
    </div>

    <div class="vx-row justify-center mt-4">
      <vs-button
        v-can="'volunteer_manage'"
        type="filled"
        color="success"
        :disabled="isSaving"
        @click="onSave"
      >
        حفظ الإعدادات
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';

const availabilityRepo = RepositoryFactory.get('availabilityRepository');

// Week order, matching the backend's weekday enum.
const WEEK_DAYS = [
  { key: 'sunday', label: 'الأحد' },
  { key: 'monday', label: 'الإثنين' },
  { key: 'tuesday', label: 'الثلاثاء' },
  { key: 'wednesday', label: 'الأربعاء' },
  { key: 'thursday', label: 'الخميس' },
  { key: 'friday', label: 'الجمعة' },
  { key: 'saturday', label: 'السبت' },
];

export default {
  name: 'AvailabilityConfigCard',
  data() {
    return {
      weekDays: WEEK_DAYS,
      isSaving: false,
      config: {
        isEnabled: false,
        days: [],
      },
    };
  },
  methods: {
    async fetchConfig() {
      const config = await availabilityRepo.fetchAvailabilityConfig();
      this.config = {
        isEnabled: !!(config && config.isEnabled),
        // Re-ordered into week order so the checkboxes always read Sunday → Saturday.
        days: this.sortByWeekOrder((config && config.days) || []),
      };
    },
    async onSave() {
      this.isSaving = true;
      try {
        // The interceptor toasts the success message for us.
        const updated = await availabilityRepo.updateAvailabilityConfig({
          isEnabled: this.config.isEnabled,
          days: this.sortByWeekOrder(this.config.days),
        });
        if (updated) {
          this.config = {
            isEnabled: !!updated.isEnabled,
            days: this.sortByWeekOrder(updated.days || []),
          };
        }
      } finally {
        this.isSaving = false;
      }
    },
    sortByWeekOrder(days) {
      const order = WEEK_DAYS.map((day) => day.key);
      return order.filter((key) => days.includes(key));
    },
  },
  created() {
    this.fetchConfig();
  },
};
</script>
